import { render, staticRenderFns } from "./SessionDayForm.vue?vue&type=template&id=27db737a"
import script from "./SessionDayForm.vue?vue&type=script&lang=js"
export * from "./SessionDayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports